import { LoadingButton } from "@mui/lab";
import { Box, ButtonBase, Typography } from "@mui/material";
import { checkRegexVietnameseAndSpace } from "helper/utils";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LanguageButton from "theme/layout/LanguageButton";
// import CoreInput from "../../common/components/forms/CoreInput";
import { useLogin } from "../hooks/useLogin";
import ChangePasswordForm from "./ChangePasswordForm";
import OTP from "./OTP";
import { useMutation } from "react-query";
import { CommonAPI } from "../../api/Channel/Common";
import { LOCAL_STORAGE, setDataSession } from "helper/session";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setIsConfirmUser } from "redux/userReducer";
import CoreInput from "common/components/forms_context/CoreInput";

export const LoginForm = () => {
  const { loginAccount, loading } = useLogin();
  const { t } = useTranslation("common");
  const { t: tUAA } = useTranslation("uaa");
  const [forgotStep, setForgotStep] = useState(0);
  const dispatch = useDispatch();
  const formContext = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
    mode: "onChange",
  });
  const isConfirmUser = useSelector((state) => state.userData.isConfirmUser);

  const { handleSubmit, control } = formContext;

  const { mutateAsync: getOTP, isLoading } = useMutation({
    mutationFn: CommonAPI.getOTP,
    onSuccess: ({ data }) => {
      if (!data.hasOwnProperty("errorCodes")) {
        dispatch(setIsConfirmUser(true));

        // setDataSession(LOCAL_STORAGE, "user", {
        //   phoneNumber: dataSuccess.phone,
        // });
        toast.success(tUAA(`message.get-otp-success`));
      }
    },
  });

  return (
    <Box className="bg-white pr-30 pl-30 flex flex-1 items-center justify-center relative">
      <Box className="absolute top-10 right-10">
        <LanguageButton />
      </Box>
      <Box className="w-full">
        <FormProvider {...formContext}>
          <form onSubmit={handleSubmit(loginAccount)}>
            <Typography variant="h5" style={{ marginBottom: 46 }}>
              {t("login")}
            </Typography>
            <CoreInput
              className="mb-20"
              name="username"
              label={tUAA("label.username")}
              required
              rules={{
                validate: (value) => {
                  if (!!value && checkRegexVietnameseAndSpace(value)) {
                    // return `${tUAA("message.msg-error-not-special", {
                    //   label: t("label.username"),
                    // })}`;
                    return "message.msg-error-not-special";
                  }
                },
              }}
              inputProps={{ maxLength: 50 }}
            />
            <CoreInput
              name="password"
              label={tUAA("label.password")}
              type="password"
              className="mb-10"
              required
              rules={{
                validate: (value) => {
                  if (!!value && value.length < 8) {
                    // return `${tUAA("message.msg-error-not-special", {
                    //   label: t("password.label"),
                    // })}`;
                    return "message.msg-error-not-special";
                  }
                },
              }}
              inputProps={{ maxLength: 15 }}
            />

            <Box className="flex justify-end space-x-5">
              <ButtonBase onClick={() => setForgotStep(2)}>
                {t("changePassword")}
              </ButtonBase>
            </Box>

            <Box className="w-full flex justify-center">
              <LoadingButton
                variant="contained"
                type="submit"
                className="w-120 h-30 mt-20"
                style={{ borderRadius: 80, marginTop: 40 }}
                disableElevation
                loading={loading}
              >
                <Typography variant="h6">{t("login").toUpperCase()}</Typography>
              </LoadingButton>
            </Box>
          </form>
          {isConfirmUser ? (
            <OTP
              isShowModal={isConfirmUser}
              isChangePassword={false}
              getOTP={getOTP}
            />
          ) : null}
        </FormProvider>
      </Box>

      {/* <ForgotPasswordForm
        open={forgotStep === 1}
        handleClose={() => setForgotStep(0)}
        onSubmit={async (val) => {
          const res = await getOtp(val.username);
          if (res) {
            setForgotStep(2);
            setUserName(val);
          }
        }}
      /> */}
      {forgotStep === 2 ? (
        <ChangePasswordForm open={true} handleClose={() => setForgotStep(0)} />
      ) : null}
    </Box>
  );
};
